document.addEventListener("DOMContentLoaded", () => {
  const arrow = document.querySelector(".product__media-next")
  if (!arrow) return

  // 1. On collecte toutes les infos des images existantes, dans l'ordre
  const mediaImgs = Array.from(
    document.querySelectorAll(".product-media-container .product__media img")
  ).map((img) => ({
    src: img.getAttribute("src"),
    srcset: img.getAttribute("srcset"),
    sizes: img.getAttribute("sizes"),
    alt: img.getAttribute("alt")
  }))

  // 2. On pointe vers l'élément <img> de la première vignette (avec la flèche)
  const firstContainer = arrow.closest(".product-media-container")
  const mainImg = firstContainer.querySelector(".product__media img")
  if (!mainImg) return

  // On stocke l'index courant (0 = première image)
  let currentIndex = 0

  arrow.addEventListener("click", () => {
    // passe à l'image suivante (cyclique)
    currentIndex = (currentIndex + 1) % mediaImgs.length
    const next = mediaImgs[currentIndex]

    // 3. On met à jour les attributs de <img>
    mainImg.setAttribute("src", next.src)
    mainImg.setAttribute("srcset", next.srcset)
    mainImg.setAttribute("sizes", next.sizes)
    mainImg.setAttribute("alt", next.alt)
  })
})
